import { createFileRoute } from "@tanstack/react-router";
import { Instagram } from "lucide-react";

import { SectionHeading } from "../components/SectionHeading";
import { CtaBand } from "../components/CtaBand";
import { InstagramFeed } from "../components/InstagramFeed";
import { socials } from "../lib/data";
import { SITE_URL, ogImageDefault, ogImageMeta } from "../lib/seo";

const title = "Werk in beeld | Fedor Timmerwerken";
const description =
  "Foto's en video's van dakkapellen, aanbouwen, kozijnen en renovaties in Dordrecht en omgeving — rechtstreeks van de Instagram van Fedor Timmerwerken.";
const socialDescription =
  "Foto's en video's van onze dakkapellen, aanbouwen en renovaties in Dordrecht en omgeving.";

export const Route = createFileRoute("/werk-in-beeld")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { name: "twitter:title", content: title },
      { property: "og:description", content: socialDescription },
      { name: "twitter:description", content: socialDescription },
      { property: "og:url", content: `${SITE_URL}/werk-in-beeld` },
      ...ogImageMeta(ogImageDefault, "Fedor Timmerwerken aan het werk in Dordrecht"),
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/werk-in-beeld` }],
  }),
  component: WerkInBeeldPage,
});

function WerkInBeeldPage() {
  return (
    <>
      <section className="border-b border-border/60 bg-secondary/20 py-14 sm:py-20">
        <div className="container-tight">
          <div className="max-w-3xl">
            <span className="font-heading text-sm font-semibold uppercase tracking-wider text-primary">
              Werk in beeld
            </span>
            <h1 className="mt-2 font-heading text-3xl font-bold leading-tight tracking-tight text-foreground sm:text-4xl lg:text-5xl">
              Zie ons vakwerk met eigen ogen
            </h1>
            <p className="mt-4 text-base leading-relaxed text-muted-foreground sm:text-lg">
              Op onze Instagram delen we foto&apos;s en video&apos;s van projecten in Dordrecht en
              omgeving: van de eerste sloop tot de laatste afwerking. Zo zie je precies hoe we
              werken en wat je van ons kunt verwachten.
            </p>
            <a
              href={socials.instagram.href}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex min-h-12 items-center justify-center gap-2 rounded-md bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground transition-colors hover:bg-primary/90"
            >
              <Instagram className="h-4 w-4" aria-hidden="true" />
              {socials.instagram.handle} op Instagram
            </a>
          </div>
        </div>
      </section>

      <section className="py-14 sm:py-20">
        <div className="container-tight">
          <SectionHeading
            eyebrow="Instagram"
            title="Onze laatste projecten"
            description="Tik op een bericht om het volledige project met foto's en video's op Instagram te bekijken."
          />
          <div className="mt-10 sm:mt-14">
            <InstagramFeed limit={12} showPageLink={false} />
          </div>
        </div>
      </section>

      <CtaBand />
    </>
  );
}
